import React from 'react';

export default function StatsBar({ stats }) {
  return (
    <div className="stats-bar">
      <div className="stat-item">
        <span className="stat-num">{stats.total}</span>
        <span className="stat-text">总数</span>
      </div>
      <div className="stat-item">
        <span className="stat-num">{stats.draft}</span>
        <span className="stat-text">草稿</span>
      </div>
      <div className="stat-item">
        <span className="stat-num">{stats.pending}</span>
        <span className="stat-text">待发布</span>
      </div>
      <div className="stat-item">
        <span className="stat-num">{stats.published}</span>
        <span className="stat-text">已发布</span>
      </div>
    </div>
  );
}